import { LobbyWidget } from '@betty/moonlight';
import { memo, useMemo } from 'react';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { useTranslation } from '@betty/i18n';
import { useSelector } from '@betty/toolkit/state';
import { selectDailyGift } from '@betty/daily-gift';

function RewardsLobbyWidget() {
  const [t] = useTranslation('rewards');

  const dailyGift = useSelector(selectDailyGift);
  const hasDailyGift = useMemo(
    () => dailyGift?.status === 'Pending',
    [dailyGift],
  );

  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleClick = () => {
    navigation.navigate('Rewards');
  };

  return (
    <LobbyWidget
      image="rewards.lobbyWidgetIcon"
      label={t('widgetLabel')}
      onClick={handleClick}
      hasUnread={hasDailyGift}
    />
  );
}

export default memo(RewardsLobbyWidget);
